<script>
import VCarouzel from '@/components/atomic/VCarouzel.vue';
import VLightBox from '@/components/atomic/VLightBox.vue';
import Gallery from '@/components/atomic/GalleryMasonry.vue';
import RoomList from '@/components/atomic/RoomList.vue';

export default {
  name: 'RoomElia',
  components: {
    VCarouzel,
    VLightBox,
    Gallery,
    RoomList,
  },
  data() {
    return {
      lightbox: false,
      lightboxIdx: 0,
      amenities: false,
      heroCarouselImages: [
        {
          id: 1,
          // e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306808/Elia-Carousel/elia_c_2_i0pksc.jpg',
          alt: 'rizes elia room',
        },
        {
          id: 4,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306808/Elia-Carousel/elia_c_6_dqfyb1.jpg',
          alt: 'rizes house elia room',
        },
        {
          id: 2,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306805/Elia-Carousel/elia_c_8_mbd1g9.jpg',
          alt: 'rizes-house elia-room',
        },
        {
          id: 3,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306804/Elia-Carousel/elia_c_9_ujjkfs.jpg',
          alt: 'rizes-house elia-room',
        },
        {
          id: 5,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306804/Elia-Carousel/elia_c_1_ftw1pl.jpg',
          alt: 'rizes-house elia-room',
        },
        {
          id: 6,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306804/Elia-Carousel/elia_c_5_pfrpby.jpg',
          alt: 'rizes-house elia-room',
        },
        {
          id: 7,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306802/Elia-Carousel/elia_c_4_ngrqnk.jpg',
          alt: 'rizes-house elia-room',
        },
        {
          id: 8,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306800/Elia-Carousel/elia_c_7_lsoaic.jpg',
          alt: 'rizes-house elia-room',
        },
        {
          id: 9,
          // eslint-disable-next-line prettier/prettier
          img:
            'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_1600/v1627306799/Elia-Carousel/elia_c_3_schq0l.jpg',
          alt: 'rizes-house elia-room',
        },
      ],
      galleryImages: [
        // e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307285/Elia-Gallery/elia_g_14_h6kdvq.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307286/Elia-Gallery/elia_g_3_zctp7y.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307284/Elia-Gallery/elia_g_4_qz36h0.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307284/Elia-Gallery/elia_g_5_ciuray.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307281/Elia-Gallery/elia_g_1_iuyz8z.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307282/Elia-Gallery/elia_g_11_tmwml5.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307282/Elia-Gallery/elia_g_2_fy0ivk.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307280/Elia-Gallery/elia_g_13_snisuu.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307280/Elia-Gallery/elia_g_8_ugejbx.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307279/Elia-Gallery/elia_g_12_f81iws.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307279/Elia-Gallery/elia_g_6_gajv5b.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307279/Elia-Gallery/elia_g_9_j2cphm.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307277/Elia-Gallery/elia_g_10_ovrqn8.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307276/Elia-Gallery/elia_g_7_jkjmw9.jpg',
      ],
      lightboxGallery: [
        // e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/
        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307285/Elia-Gallery/elia_g_14_h6kdvq.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307286/Elia-Gallery/elia_g_3_zctp7y.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307284/Elia-Gallery/elia_g_4_qz36h0.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307284/Elia-Gallery/elia_g_5_ciuray.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307281/Elia-Gallery/elia_g_1_iuyz8z.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307282/Elia-Gallery/elia_g_11_tmwml5.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307282/Elia-Gallery/elia_g_2_fy0ivk.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307280/Elia-Gallery/elia_g_13_snisuu.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307280/Elia-Gallery/elia_g_8_ugejbx.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307279/Elia-Gallery/elia_g_12_f81iws.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307279/Elia-Gallery/elia_g_6_gajv5b.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307279/Elia-Gallery/elia_g_9_j2cphm.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307277/Elia-Gallery/elia_g_10_ovrqn8.jpg',

        'https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_800/v1627307276/Elia-Gallery/elia_g_7_jkjmw9.jpg',
      ],
      general: [
        this.$t('pageElia.amenities.general.1'),
        this.$t('pageElia.amenities.general.2'),
        this.$t('pageElia.amenities.general.3'),
        this.$t('pageElia.amenities.general.4'),
        this.$t('pageElia.amenities.general.5'),
        this.$t('pageElia.amenities.general.6'),
        this.$t('pageElia.amenities.general.7'),
        this.$t('pageElia.amenities.general.8'),
        this.$t('pageElia.amenities.general.9'),
        this.$t('pageElia.amenities.general.10'),
      ],
      kitchen: [
        this.$t('pageElia.amenities.kitchen.1'),
        this.$t('pageElia.amenities.kitchen.2'),
        this.$t('pageElia.amenities.kitchen.3'),
        this.$t('pageElia.amenities.kitchen.4'),
        this.$t('pageElia.amenities.kitchen.5'),
        this.$t('pageElia.amenities.kitchen.6'),
        this.$t('pageElia.amenities.kitchen.7'),
        this.$t('pageElia.amenities.kitchen.8'),
        this.$t('pageElia.amenities.kitchen.9'),
      ],
      security: [
        this.$t('pageElia.amenities.security.1'),
        this.$t('pageElia.amenities.security.2'),
        this.$t('pageElia.amenities.security.3'),
      ],
      other: [
        this.$t('pageElia.amenities.other.1'),
        this.$t('pageElia.amenities.other.2'),
        this.$t('pageElia.amenities.other.3'),
        this.$t('pageElia.amenities.other.4'),
        this.$t('pageElia.amenities.other.5'),
        this.$t('pageElia.amenities.other.6'),
        this.$t('pageElia.amenities.other.7'),
        this.$t('pageElia.amenities.other.8'),
        this.$t('pageElia.amenities.other.9'),
        this.$t('pageElia.amenities.other.10'),
      ],
    };
  },
  methods: {
    imageClicked(idx) {
      this.lightbox = true;
      this.lightboxIdx = idx;
    },
    checkScreen() {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 750) {
        this.amenities = true;
        return;
      }
      this.amenities = false;
    },
  },
  created() {
    window.addEventListener('resize', this.checkScreen);
    const windowWidth = window.innerWidth;
    if (windowWidth >= 750) {
      this.amenities = true;
      return;
    }
  },
};
</script>

<template>
  <div class="elia">
    <header class="header">
      <v-carouzel :slides="heroCarouselImages" slideHeight="80"> </v-carouzel>
    </header>
    <section class="description">
      <div class="description__text">
        <p class="title">{{ this.$t('pageElia.title') }}</p>
        <p class="content">{{ this.$t('pageElia.content.p1') }}</p>
        <p class="content">{{ this.$t('pageElia.content.p2') }}</p>
        <p class="content">{{ this.$t('pageElia.content.p3') }}</p>
        <p class="content">{{ this.$t('pageElia.content.p4') }}</p>
        <ul class="list">
          <li>{{ this.$t('pageElia.content.l1') }}</li>
          <li>{{ this.$t('pageElia.content.l2') }}</li>
          <li>{{ this.$t('pageElia.content.l3') }}</li>
          <li>{{ this.$t('pageElia.content.l4') }}</li>
        </ul>
      </div>
      <img
        class="description__img"
        src="https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307280/Elia-Gallery/elia_g_13_snisuu.jpg"
      />
    </section>
    <section class="info">
      <img
        class="info__img"
        src="https://res.cloudinary.com/rizeshouse/image/upload/e_auto_color,e_auto_saturation,e_auto_brightness,e_auto_contrast,c_scale,q_auto:best,w_600/v1627307279/Elia-Gallery/elia_g_9_j2cphm.jpg"
      />
      <div class="info__text">
        <h3 class="heading">{{ this.$t('pageElia.info.heading') }}</h3>
        <ul>
          <li>
            <img src="@/assets/icons/user-solid.svg" alt="Rizes House" />{{
              this.$t('pageElia.info.l1')
            }}
          </li>
          <li>
            <img src="@/assets/icons/crop-alt-solid.svg" alt="Rizes House" />{{
              this.$t('pageElia.info.l2')
            }}
          </li>
          <li>
            <img src="@/assets/icons/crop-alt-solid.svg" alt="Rizes House" />{{
              this.$t('pageElia.info.l3')
            }}
          </li>
          <hr />
          <li>
            <b>{{ this.$t('pageElia.info.l4') }}</b>
          </li>
          <li>
            <img src="@/assets/icons/bed-solid.svg" alt="Rizes House" />{{
              this.$t('pageElia.info.l5')
            }}
          </li>
          <hr />
          <li>
            <b>{{ this.$t('pageElia.info.l6') }}</b>
          </li>
          <li>
            <img src="@/assets/icons/bed-solid.svg" alt="Rizes House" />{{
              this.$t('pageElia.info.l7')
            }}
          </li>
          <hr />
          <li>
            <b>{{ this.$t('pageElia.info.l8') }}</b>
          </li>
          <li>
            <img src="@/assets/icons/bed-solid.svg" alt="Rizes House" />{{
              this.$t('pageElia.info.l9')
            }}
          </li>
          <hr />
          <li>
            <b>{{ this.$t('pageElia.info.l10') }}</b>
          </li>
          <hr />
          <li>
            <b>{{ this.$t('pageElia.info.l11') }}</b>
          </li>
        </ul>
      </div>
    </section>
    <section class="amenities">
      <button class="btn-amenities" @click="amenities = !amenities">
        περισοτερες παροχες
        <img src="@/assets/icons/chevron-down-solid.svg" alt="" />
      </button>
      <div class="amenities__list" v-if="amenities">
        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ this.$t('pageElia.amenities.general.heading') }}
          </h3>
          <room-list :benefitsArr="general" columns="1"></room-list>
        </div>

        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ this.$t('pageElia.amenities.kitchen.heading') }}
          </h3>
          <room-list :benefitsArr="kitchen" columns="1"></room-list>
        </div>

        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ this.$t('pageElia.amenities.security.heading') }}
          </h3>
          <room-list :benefitsArr="security" columns="1"></room-list>
        </div>

        <div class="column">
          <h3 class="heading-3 heading-3--light mb-2">
            {{ this.$t('pageElia.amenities.other.heading') }}
          </h3>
          <room-list :benefitsArr="other" columns="1"></room-list>
        </div>
      </div>
    </section>
    <section class="image-gallery">
      <gallery
        :images="galleryImages"
        imageAlt="rizes-house rodia halkidiki"
        @imageIndx="imageClicked"
      ></gallery>
    </section>

    <v-light-box
      :showLightbox="lightbox"
      @hideLightbox="lightbox = false"
      :images="lightboxGallery"
      :startAt="lightboxIdx"
    ></v-light-box>
  </div>
</template>

<style scoped lang="scss">
.elia {
  background-color: hsl(var(--clr-primary-700));
}

hr {
  border: 0;
  border-top: 1px solid hsl(var(--clr-primary-100));
  margin: 4px 0;
}

.description,
.info {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 45px 0;
  background-color: hsl(var(--clr-primary-700));
}

.description {
  &__text {
    max-width: 650px;
    padding: 32px;
    background-color: hsl(var(--clr-primary-500));
    color: hsl(var(--clr-primary-100));

    .title {
      font-size: 20px;
      font-weight: 600;
      line-height: 31.6px;
    }

    .title,
    .content {
      margin-bottom: 16px;
    }

    .list {
      font-size: 14px;

      li {
        margin-bottom: 8px;
      }
    }
  }

  &__img {
    height: 400px;
    width: auto;
  }
}

.heading {
  margin-bottom: 16px;
  font-size: 22px;
  font-weight: 400;
  text-transform: uppercase;
}

.info {
  &__img {
    height: 400px;
    width: auto;
  }

  &__text {
    min-width: 450px;
    padding: 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: hsl(var(--clr-primary-500));
    color: hsl(var(--clr-primary-100));

    li {
      display: flex;
      font-size: 16px;
      padding: 8px 0;

      img {
        width: 24px;
        height: auto;
        margin-right: 3px;
      }
    }
  }
}

.image-gallery {
  background-color: hsl(var(--clr-primary-700));
}

.btn-amenities {
  display: none;
}

.amenities {
  &__list {
    width: 100%;
    padding: 40px 0;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-around;
    justify-content: space-evenly;
    background-color: hsl(var(--clr-primary-500));

    .column {
      width: 205px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
    }
  }
}

@media (max-width: 900px) {
  .description,
  .info {
    flex-direction: column;
    padding: 15px 0;
  }

  .description {
    &__text {
      min-width: 100%;
    }

    &__img {
      display: none;
    }
  }

  .info {
    &__text {
      min-width: 100%;
    }

    &__img {
      display: none;
    }
  }
}

@media (max-width: 750px) {
  .amenities {
    &__list {
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .column + .column {
      margin-top: 20px;
    }
  }

  .btn-amenities {
    all: unset;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 16px 0;
    background-color: hsl(var(--clr-accent-700));
    color: hsl(var(--clr-primary-100));
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    // text-align: center;

    img {
      width: 20px;
      height: auto;
      margin-left: 8px;
    }
  }
}
</style>
